import { useState } from 'react'
import Header from '@components/Header/Header'
import AccountNumberInput from '@components/AccountNumberInput/AccountNumberInput'
import BottomSheetDropdown, { BottomSheetDropdownOption } from '@components/BottomSheetDropdown/BottomSheetDropdown'
import NumericKeyboard from '@components/NumericKeyboard/NumericKeyboard'
import PrimaryButton from '@components/PrimaryButton/PrimaryButton'
import { useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import {
  Container,
  ContentContainer,
  InputSection,
  InputWrapper,
  DropdownWrapper,
  KeyboardSection
} from './BPJS.styles'

const BPJS = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [accountNumber, setAccountNumber] = useState('')
  const [selectedMonth, setSelectedMonth] = useState<BottomSheetDropdownOption | undefined>()

  const months: BottomSheetDropdownOption[] = [
    { label: t('bpjs.months.january') },
    { label: t('bpjs.months.february') },
    { label: t('bpjs.months.march') },
    { label: t('bpjs.months.april') },
    { label: t('bpjs.months.may') },
    { label: t('bpjs.months.june') },
    { label: t('bpjs.months.july') },
    { label: t('bpjs.months.august') },
    { label: t('bpjs.months.september') },
    { label: t('bpjs.months.october') },
    { label: t('bpjs.months.november') },
    { label: t('bpjs.months.december') },
  ]

  const handleKeyboardChange = (value: string | 'delete') => {
    if (value === 'delete') {
      setAccountNumber(prev => prev.slice(0, -1))
    } else {
      setAccountNumber(prev => prev + value)
    }
  }

  const handleAccountNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAccountNumber(e.target.value)
  }

  const handleContinue = () => {
    navigate('/payment-confirm', {
      state: {
        accountNumber,
        month: selectedMonth?.label,
        serviceType: 'bpjs'
      }
    })
  }

  return (
    <Container>
      <Header
        title={t('bpjs.header')}
        showBackButton={true}
        onBackClick={() => navigate(-1)}
      />
      <ContentContainer>
        <InputSection>
          <InputWrapper>
            <AccountNumberInput
              title={t('bpjs.accountNumberLabel')}
              value={accountNumber}
              onChange={handleAccountNumberChange}
              placeholder={t('bpjs.accountNumberPlaceholder')}
              inputMode="none"
            />
          </InputWrapper>
          <DropdownWrapper>
            <BottomSheetDropdown
              placeholder={t('bpjs.monthPlaceholder')}
              options={months}
              value={selectedMonth}
              onChange={setSelectedMonth}
              showSearch={false}
            />
          </DropdownWrapper>
        </InputSection>

        <KeyboardSection>
          <NumericKeyboard onChange={handleKeyboardChange} />
          <PrimaryButton
            onClick={handleContinue}
            disabled={!accountNumber || !selectedMonth}
          >
            {t('common.continue')}
          </PrimaryButton>
        </KeyboardSection>
      </ContentContainer>
    </Container>
  )
}

export default BPJS
